const doc = [({"en":({"js":({"admin":({"economy":({"subscription_renewal_generations":({"subscription_renewals":"Subscription renewals"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;